import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { QueryPreviewTabs, } from '../types.js';
import { QueryPreviewHeader } from '../components/QueryPreviewHeader.js';
import { QueryPreviewInfo, } from '../components/QueryPreviewInfo.js';
import { QueryPreviewApi, } from '../components/QueryPreviewApi.js';
import { QueryPreviewSubscriptions, } from '../components/QueryPreviewSubscriptions.js';
import { QueryPreviewTags, } from '../components/QueryPreviewTags.js';
import { NoRtkQueryApi } from '../components/NoRtkQueryApi.js';
import { mapProps } from './mapProps.js';
import { QueryPreviewActions, } from '../components/QueryPreviewActions.js';
import { isTabVisible } from '../utils/tabs.js';
import { QueryPreviewData, } from '../components/QueryPreviewData.js';
const queryPreviewCss = (theme) => ({
    flex: '1 1 50%',
    overflowX: 'hidden',
    oveflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    '& pre': {
        border: 'inherit',
        borderRadius: '3px',
        lineHeight: 'inherit',
        color: 'inherit',
    },
    backgroundColor: theme.BACKGROUND_COLOR,
});
const MappedQueryPreviewTags = mapProps(({ selectors, selectorsSource, isWideLayout, resInfo }) => ({
    resInfo,
    tags: selectors.selectCurrentQueryTags(selectorsSource),
    isWideLayout,
}))(QueryPreviewTags);
const MappedQueryPreviewInfo = mapProps(({ resInfo, isWideLayout }) => ({ resInfo, isWideLayout }))(QueryPreviewInfo);
const MappedQueryPreviewData = mapProps(({ resInfo, isWideLayout }) => ({
    data: resInfo?.state?.data,
    isWideLayout,
}))(QueryPreviewData);
const MappedQuerySubscriptipns = mapProps(({ selectors, selectorsSource, isWideLayout }) => ({
    isWideLayout,
    subscriptions: selectors.selectSubscriptionsOfCurrentQuery(selectorsSource),
}))(QueryPreviewSubscriptions);
const MappedApiPreview = mapProps(({ isWideLayout, selectors, selectorsSource }) => ({
    isWideLayout,
    apiState: selectors.selectApiOfCurrentQuery(selectorsSource),
    apiStats: selectors.selectApiStatsOfCurrentQuery(selectorsSource),
}))(QueryPreviewApi);
const MappedQueryPreviewActions = mapProps(({ isWideLayout, selectorsSource, selectors }) => ({
    isWideLayout,
    actionsOfQuery: selectors.selectActionsOfCurrentQuery(selectorsSource),
}))(QueryPreviewActions);
const tabs = [
    {
        label: 'Data',
        value: QueryPreviewTabs.data,
        component: MappedQueryPreviewData,
        visible: {
            query: true,
            mutation: true,
            default: true,
        },
    },
    {
        label: 'Query',
        value: QueryPreviewTabs.queryinfo,
        component: MappedQueryPreviewInfo,
        visible: {
            query: true,
            mutation: true,
            default: true,
        },
    },
    {
        label: 'Actions',
        value: QueryPreviewTabs.actions,
        component: MappedQueryPreviewActions,
        visible: {
            query: true,
            mutation: true,
            default: true,
        },
    },
    {
        label: 'Tags',
        value: QueryPreviewTabs.queryTags,
        component: MappedQueryPreviewTags,
        visible: {
            query: true,
            mutation: false,
            default: true,
        },
    },
    {
        label: 'Subs',
        value: QueryPreviewTabs.querySubscriptions,
        component: MappedQuerySubscriptipns,
        visible: {
            query: true,
            mutation: false,
            default: true,
        },
    },
    {
        label: 'Api',
        value: QueryPreviewTabs.apiConfig,
        component: MappedApiPreview,
    },
];
export class QueryPreview extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.renderLabelWithCounter = (label, counter) => {
            let counterAsString = counter.toFixed(0);
            if (counterAsString.length > 3) {
                counterAsString = counterAsString.slice(0, 2) + '...';
            }
            return `${label}(${counterAsString})`;
        };
        this.renderTabLabel = (tab) => {
            const { selectors, selectorsSource, resInfo } = this.props;
            const tabCount = selectors.selectTabCounters(selectorsSource)[tab.value];
            let tabLabel = tab.label;
            if (tabLabel === 'query' && resInfo?.type === 'mutation') {
                tabLabel = resInfo.type;
            }
            if (tabCount > 0) {
                return this.renderLabelWithCounter(tabLabel, tabCount);
            }
            return tabLabel;
        };
    }
    render() {
        const { resInfo, selectedTab, onTabChange, hasNoApis } = this.props;
        const { component: TabComponent } = tabs.find((tab) => tab.value === selectedTab) || tabs[0];
        if (!resInfo) {
            return (_jsxs("div", { css: queryPreviewCss, children: [_jsx(QueryPreviewHeader, { selectedTab: selectedTab, onTabChange: onTabChange, tabs: tabs.filter((tab) => isTabVisible(tab, 'default')), renderTabLabel: this.renderTabLabel }), hasNoApis && _jsx(NoRtkQueryApi, {})] }));
        }
        return (_jsxs("div", { css: queryPreviewCss, children: [_jsx(QueryPreviewHeader, { selectedTab: selectedTab, onTabChange: onTabChange, tabs: tabs.filter((tab) => isTabVisible(tab, resInfo.type)), renderTabLabel: this.renderTabLabel }), _jsx(TabComponent, { ...this.props })] }));
    }
}
